<div class="flex flex-col gap-6 w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4">{{ translateServ.dictionary['STEP_ADDR_TITLE'] }}</h2>
    <p class="text-center text-gray-400">{{ translateServ.dictionary['STEP_ADDR_TEXT'] }}</p>

    <p-toast></p-toast>

    <div class="card p-card-modern p-datatable-form">
        <p-table [value]="addresses" [tableStyle]="{'min-width': '70rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_Type'] }}</th>
                    <th style="width: 20%;">Full Address</th>
                    <th style="width: 6%;">{{ translateServ.dictionary['STEP_TAB_TIT_PostalCode'] }}</th>
                    <th style="width: 4%;">{{ translateServ.dictionary['STEP_TAB_TIT_PostalBox'] || 'Postal Box'}} </th>
                    <th pSortableColumn="House" style="min-width: 6rem;">
                        {{ translateServ.dictionary['MAINT_IN_TIT_HOUSENUM'] || 'House'}}
                        <p-sortIcon field="House"></p-sortIcon>
                        <br />
                        <small>{{ translateServ.dictionary['MAINT_IN_TIT_APARTMENT'] || 'Apartment' }}</small>
                    </th>
                    <th style="width: 8%;"> Entrence</th> 
                    <th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] }}</th>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] }}</th>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] }}</th>
                    <th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-addressEntry>
                <tr>
                    <td>
                        <p-autoComplete
                            [(ngModel)]="addressEntry.addrType"
                            (onSelect)="onAddressTypeChange(addressEntry, $event.value)"
                            (onClear)="onAddressTypeChange(addressEntry, null)"
                            (ngModelChange)="emitChanges()"
                            [suggestions]="filteredAddressTypes"
                            (completeMethod)="searchAddressTypes($event)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_TYPE_HELPER']"
                            field="label"
                            [showEmptyMessage]="false"
                            styleClass="w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>

                    <!-- Full Address column -->
                    <td>
                        <div class="flex flex-col gap-2">
                            <p-autoComplete
                                [(ngModel)]="addressEntry.country"
                                (ngModelChange)="emitChanges()"
                                (onSelect)="onCountryChange(addressEntry, $event.value)"
                                (onClear)="onCountryChange(addressEntry, null)"
                                [suggestions]="filteredCountries"
                                (completeMethod)="searchCountries($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_COUNTRY_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                            ></p-autoComplete>

                            <p-autoComplete
                                [(ngModel)]="addressEntry.city"
                                (ngModelChange)="emitChanges()"
                                (onSelect)="onCityChange(addressEntry, $event.value)"
                                (onClear)="onCityChange(addressEntry, null)"
                                [suggestions]="filteredCities"
                                (completeMethod)="searchCities($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_CITY_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                                [disabled]="!addressEntry.country"
                            ></p-autoComplete>

                            <p-autoComplete
                                [(ngModel)]="addressEntry.street"
                                (ngModelChange)="emitChanges()"
                                (onSelect)="onStreetChange(addressEntry, $event.value)"
                                (onClear)="onStreetChange(addressEntry, null)"
                                [suggestions]="filteredStreetNames"
                                (completeMethod)="searchStreetNames($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_STREET_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                                [disabled]="!addressEntry.city"
                            ></p-autoComplete>
                        </div>
                    </td>

                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="addressEntry.postalCode"
                            (ngModelChange)="emitChanges()"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_POSTAL_HELPER']"
                            [maxlength]="POSTAL_CODE_LENGTH"
                            pattern="[0-9]{7}"
                            [title]="translateServ.dictionary['POSTAL_CODE_TITLE']"
                        />
                    </td>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="addressEntry.postalBox"
                            (ngModelChange)="emitChanges()"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_BOX_HELPER']"
                            pattern="[0-9]"
                            [title]="translateServ.dictionary['POSTAL_BOX_TITLE'] || 'Entrence'"
                        />
                    </td>
                   <td>
                        <div class="flex flex-col gap-1">
                            <!-- House Number -->
                            <input
                            pInputText
                            type="text"
                            [(ngModel)]="addressEntry.houseNumber"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_TAB_TIT_HOUSENUM']"
                            />

                            <!-- Apartment -->
                            <input
                            pInputText
                            type="text"
                            [(ngModel)]="addressEntry.apartment"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['MAINT_IN_TIT_APARTMENT'] || 'Apartment'"
                            />
                        </div>
                    </td>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="addressEntry.entrence"
                            (ngModelChange)="emitChanges()"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_TAB_TIT_ENTERENCE']"
                        />
                    </td>
                    <td>
                        <textarea
                            pInputTextarea
                            [(ngModel)]="addressEntry.description"
                            (ngModelChange)="emitChanges()"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['MAINT_IN_TIT_DESC']"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            {{ getRemainingChars(addressEntry.description) }} {{ translateServ.dictionary['CHARS_REMAINING'] }}
                        </div>
                    </td>
                    <td>
                        <p-tag
                            [value]="addressEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(addressEntry)"
                            [severity]="addressEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <td>
                        <p-tag
                            [value]="addressEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(addressEntry)"
                            [severity]="addressEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <div class="flex gap-2">
                            <button
                                *ngIf="isCreate"
                                pButton
                                type="button"
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                                (click)="removeEntry(addressEntry)"
                                [label]="translateServ.dictionary['TOOLTIP_DELETE_ENTRY'] || 'Delete'">
                            </button>
                            <button
                                *ngIf="!isCreate"
                                pButton
                                type="button"
                                icon="pi pi-check"
                                class="p-button-rounded p-button-text p-button-sm p-button-info"
                                (click)="applyRowChanges(addressEntry)"
                                [label]="translateServ.dictionary['APPLY_CHANGES'] || 'Apply Changes'">
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" *ngIf="isCreate">
                <tr>
                    <td>
                        <p-autoComplete
                            [(ngModel)]="newEntry.addrType"
                            [suggestions]="filteredAddressTypes"
                            (onSelect)="onAddressTypeChange(newEntry, $event.value)"
                            (onClear)="onAddressTypeChange(newEntry, null)"
                            (completeMethod)="searchAddressTypes($event)"
                            [forceSelection]="false"
                            [dropdown]="true"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_TYPE_HELPER']"
                            field="label"
                            [showEmptyMessage]="false"
                            styleClass="w-full"
                            inputStyleClass="p-inputtext-sm"
                            [completeOnFocus]="true"
                            [appendTo]="'body'"
                        ></p-autoComplete>
                    </td>

                    <!-- Full Address column -->
                    <td>
                        <div class="flex flex-col gap-2">
                            <p-autoComplete
                                [(ngModel)]="newEntry.country"
                                (ngModelChange)="emitChanges()"
                                (onSelect)="onCountryChange(newEntry, $event.value)"
                                (onClear)="onCountryChange(newEntry, null)"
                                [suggestions]="filteredCountries"
                                (completeMethod)="searchCountries($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_COUNTRY_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                            ></p-autoComplete>

                            <p-autoComplete
                                [(ngModel)]="newEntry.city"
                                (ngModelChange)="emitChanges()"
                                (onSelect)="onCityChange(newEntry, $event.value)"
                                (onClear)="onCityChange(newEntry, null)"
                                [suggestions]="filteredCities"
                                (completeMethod)="searchCities($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_CITY_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                            ></p-autoComplete>

                            <p-autoComplete
                                [(ngModel)]="newEntry.street"
                                (onSelect)="onStreetChange(newEntry, $event.value)"
                                (onClear)="onStreetChange(newEntry, null)"
                                [suggestions]="filteredStreetNames"
                                (completeMethod)="searchStreetNames($event)"
                                [forceSelection]="false"
                                [dropdown]="true"
                                [placeholder]="translateServ.dictionary['STEP_ADDR_STREET_HELPER']"
                                field="label"
                                [showEmptyMessage]="false"
                                styleClass="w-full"
                                inputStyleClass="p-inputtext-sm"
                                [completeOnFocus]="true"
                                [appendTo]="'body'"
                            ></p-autoComplete>
                        </div>
                    </td>

                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.postalCode"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_POSTAL_HELPER']"
                            [maxlength]="POSTAL_CODE_LENGTH"
                            pattern="[0-9]{7}"
                            [title]="translateServ.dictionary['POSTAL_CODE_TITLE']"
                        />
                    </td>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.postalBox"
                            (ngModelChange)="emitChanges()"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_ADDR_BOX_HELPER']"
                            pattern="[0-9]"
                            [title]="translateServ.dictionary['POSTAL_BOX_TITLE']"
                        />
                    </td>
                    <td>
                        <div class="flex flex-col gap-1">
                            <!-- House Number -->
                            <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.houseNumber"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_TAB_TIT_HOUSENUM']"
                            />

                            <!-- Apartment -->
                            <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.appartment"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['MAINT_IN_TIT_APARTMENT'] || 'Apartment'"
                            />
                        </div>
                    </td>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.entrence"
                            (ngModelChange)="emitChanges()"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['STEP_TAB_TIT_ENTERENCE']"
                        />
                    </td>
                    <td>
                        <textarea
                            pInputTextarea
                            [(ngModel)]="newEntry.description"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['MAINT_IN_TIT_DESC']"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            {{ getRemainingChars(newEntry.description) }} {{ translateServ.dictionary['CHARS_REMAINING'] }}
                        </div>
                    </td>
                    <td>
                        <p-tag
                            [value]="newEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(newEntry)"
                            [severity]="newEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <td>
                        <p-tag
                            [value]="newEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(newEntry)"
                            [severity]="newEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <p-button
                            [label]="translateServ.dictionary['ADD']"
                            icon="pi pi-plus"
                            severity="success"
                            styleClass="p-button-text p-button-sm"
                            (onClick)="addEntry()">
                        </p-button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" class="text-center text-gray-500">{{ translateServ.dictionary['STEP_ADDR_MSG'] }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>


    <!-- Optional Tab Message (only if not dialog mode) AT BOTTOM -->
	<ng-container *ngIf="!isDialogMode">
		<div class="flex flex-col items-center mb-2 mt-4">
			<div class="p-2 rounded bg-blue-50 text-blue-700 border border-blue-200 w-full text-center">
				{{ translateServ.dictionary['STEP_PROFILERS_OPTIONAL_MSG'] || 'This step is optional. You can skip to the last step if you wish.' }}
			</div>
			<button pButton type="button" class="p-button-text p-button-sm mt-2" (click)="skipToLastStep.emit()">
				{{ translateServ.dictionary['STEP_PROFILERS_SKIP_TO_LAST'] || 'Skip to Last Step' }}
				<i [ngClass]="dirServ.isRtl() ? 'pi pi-backward' : 'pi pi-forward'" class="mr-1"></i>
			</button>
		</div>
	</ng-container>
    
    <!-- Navigation Buttons -->
    <div class="flex justify-between pt-6">
        <ng-container *ngIf="!isDialogMode">
            <p-button
                [label]="translateServ.dictionary['BACK']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
                [iconPos]="dirServ.isRtl() ? 'right' : 'left'"
                severity="secondary"
                (onClick)="goToPreviousStep()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['NEXT']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
                [iconPos]="dirServ.isRtl() ? 'left' : 'right'"
                (onClick)="validateAndProceed()">
            </p-button>
        </ng-container>
        <ng-container *ngIf="isDialogMode">
            <p-button
                [label]="translateServ.dictionary['CANCEL'] || 'Cancel'"
                [icon]="'pi pi-times'"
                severity="secondary"
                (onClick)="closeDialog()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['SAVE'] || 'Save'"
                [icon]="'pi pi-save'"
                (onClick)="saveAndSubmit()"
                [disabled]="addresses.length === 0">
            </p-button>
        </ng-container>
    </div>
</div>
